module.exports = __webpack_public_path__ + "static/media/exclamation-point-icon.17a4e289.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/exclamation-point-icon.png
// module id = 900
// module chunks = 0